<template>
  <div id="badges"></div>
</template>

<script>
export default {
  name: 'Badges',
  mounted() {
    import('./src/badges-init').then((badgesInit) => {
      this.$nextTick(() => badgesInit.launch());
    });
  },
};
</script>

<style scoped>
#badges {
  display: flex;
  justify-content: center;
  height: 100vh;
}
</style>
